export default __webpack_public_path__ + "static/vytal-logo-c5cee44f4e09b65efbed34d96309d3c9.png";